import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrandService } from 'app/services/models/brand.service';
import { CategoryService } from 'app/services/models/category.service';
import { CompanyService } from 'app/services/models/company.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { ProductService } from 'app/services/models/product.service';
import { TaxService } from 'app/services/models/tax.service';
import { UnitTypeService } from 'app/services/models/unit-type.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.scss']
})
export class CreateProductComponent implements OnInit {
  @BlockUI('section-blocks') blockUI: NgBlockUI;
  productForm: FormGroup; // Form için tanımlama

  categories: any[] = [];
  currencies: any[] = [];
  unitTypes: any[] = [];
  taxes: any[] = [];
  brands: any[];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private unitTypeService: UnitTypeService,
    private categoryService: CategoryService,
    private currencyService: CurrencyService,
    private productService: ProductService,
    private toastrService: ToastrService,
    private taxService: TaxService,
    private brandService: BrandService) {

    this.productForm = this.fb.group({
      title: ['', Validators.required],
      currencyId: [1],
      categoryId: [null],
      saleTaxId: [null],
      salePrice: [null],
      purchasePrice: [null],
      purchaseSaleTaxId: [null],
      unitTypeId: [1],
      productType: [true],
      brandModalId:[null]
    });
  }

  async ngOnInit() {
    await this.getAllCategories()
    await this.getAllUnitTypes();
    await this.getAllTax();
    await this.getAllCurrencies();
    await this.getAllBrand();
  }

  async getAllBrand() {
    const data = await this.brandService.getBrands();
    // flatMap kullanarak tek katmanlı bir dizi oluşturuyoruz
    this.brands = data.flatMap(brand =>
      brand.brandModels.map(model => ({
        id: model.id,                // Modelin ID'sini ekliyoruz
        name: model.modelName,        // Model ismi
        brandName: brand.brandName    // Grup başlığı olarak marka ismi
      }))
    );

    console.log(this.brands);

  }

  async getAllTax() {
    const tax = await this.taxService.getAllTax(0, 100, '');
    console.log(tax);
    this.taxes = tax.taxex;
  }

  async getAllUnitTypes() {
    const unitType = await this.unitTypeService.getAllUnitType(0, 100, '');
    this.unitTypes = unitType.unitTypes;
    console.log(this.unitTypes);
  }

  async getAllCurrencies() {
    const currency = await this.currencyService.getAllPageCurrency(0, 100, '');
    this.currencies = currency.currenies;
    console.log(this.currencies);
  }

  async getAllCategories() {
    const category = await this.categoryService.getAllCategory(0, 100, '', 1);
    this.categories = category.categories;
    console.log(this.categories);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSubmit() {
    this.blockUI.start("ürün ekleniyor...");
    if (this.productForm.valid) {
      console.log(this.productForm.value);
      const response = await this.productService.createProduct({
        name: this.productForm.value.title,
        saleTaxId: this.productForm.value.saleTaxId,
        salePrice: this.productForm.value.salePrice,
        categoryId: this.productForm.value.categoryId,
        currencyId: this.productForm.value.currencyId,
        unitTypeId: this.productForm.value.unitTypeId,
        warehouseId: 1,
        productCount: 0,
        productType: this.productForm.value.productType,
        purchaseTaxId: this.productForm.value.purchaseTaxId,
        purchasePrice: this.productForm.value.purchasePrice,
        brandModalId:this.productForm.value.brandModalId
      });
      if (response.status) {
        this.blockUI.stop();
        this.productService.sendEvent(true);
        this.closeModal();
        this.toastrService.success(response.message);
      } else {
        this.blockUI.stop();
        this.toastrService.error(response.message);
      }
    }
  }
}